import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Select from "../../../../components/select/select";
import Button from "../../../../components/buttons/button";
import { useFormik } from "formik";
import MessagePopup from "../../../../components/popups/messagePopup";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { useState } from "react";

const ShipmentDetail = () => {
  const [save, setSave] = useState(false);

  const { t } = useTranslation();
  const { id } = useParams();
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      setSave(true);
    },
  });
  const shipmentType = [
    { label: t("all"), value: "all" },
    { label: t("normal"), value: "normal" },
    { label: t("fast"), value: "fast" },
  ];
  const handleShippingStatus = (e) => {
    formik.setFieldValue("shipmentType", e.value);
  };

  return (
    <main className="relative ">
      <h2 className="my-4 text-lg font-medium capitalize">
        {t("shipmentDetails")} {id}
      </h2>

      <form onSubmit={formik.handleSubmit} className="space-y-4">
        <div className="flex flex-wrap justify-between gap-4 md:flex-nowrap">
          <section className="flex flex-col w-full">
            <h3 className="text-lg font-medium capitalize text-mainBlue">
              {t("shipmentInfo")}
            </h3>
            <div className="flex-1 p-4 space-y-4 bg-white rounded-2xl">
              <div className="flex items-center justify-between">
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("shipmentNumber")}</p>
                  <p>{id}</p>
                </div>
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("sentDate")}</p>
                  <p>27/7/2024</p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("type")}</p>
                  <Select
                    onChange={handleShippingStatus}
                    options={shipmentType}
                    placeholder={t("normal")}
                  />
                </div>
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("weight")}</p>
                  <p>12.5KG</p>
                </div>
              </div>
            </div>
          </section>
          <section className="flex flex-col w-full">
            <h3 className="text-lg font-medium capitalize text-mainBlue ">
              {t("customerInfo")}
            </h3>
            <div className="flex-1 p-4 space-y-4 bg-white rounded-2xl">
              <div className="flex items-center justify-between">
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("customerName")}</p>
                  <p>سارة الخطيب</p>
                </div>
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("phone")}</p>
                  <p>+971 55 987 6543</p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="my-2 capitalize text-mainGray">{t("mail")}</p>
                  <p>sara.khatib@example.com</p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section>
          <h3 className="text-lg font-medium capitalize text-mainBlue">
            {t("shippingInfo")}
          </h3>
          <div className="flex flex-wrap items-center justify-between p-4 space-y-4 bg-white md:flex-nowrap rounded-2xl">
            <div className="w-full">
              <p className="my-2 capitalize text-mainGray">{t("address")}</p>
              <p>برج خليفة، دبي، الإمارات العربية المتحدة</p>
            </div>
            <div className="w-full">
              <p className="my-2 capitalize text-mainGray">{t("currentStatus")}</p>
              <p className="p-2 bg-[#D9E5FF] w-fit rounded-2xl text-center">
                في الميناء
              </p>
            </div>
          </div>
        </section>
        <section>
          <h3 className="text-lg font-medium capitalize text-mainBlue">{t("notes")}</h3>
          <div className="p-4 space-y-4 bg-white rounded-2xl">
            <p>
              الشحنة وصلت إلى ميناء دبي وتنتظر التخليص الجمركي. من المتوقع أن تكون جاهزة
              للتسليم خلال 2-3 أيام.
            </p>
          </div>
        </section>
        <Button text={t("saveChanges")} className={"bg-mainRed py-2 my-4"} />
      </form>
      <MessagePopup
        text={t("savedSuccess")}
        icon={<ShipmentDeliveredIcon className="size-20" />}
        state={save}
        setState={setSave}
      />
    </main>
  );
};

export default ShipmentDetail;
